import { Products } from 'merchandise-lib/constants/Product';
const ProductsSet = new Set(Object.values(Products));
export const isValidApiName = apiName => {
  return apiName !== null && apiName !== undefined && typeof apiName === 'string' && ProductsSet.has(apiName);
};
export const isValidQuantityPackApiName = quantityPackApiName => {
  return typeof quantityPackApiName === 'string' && ['additional-marketing-contacts', 'additional-sales-seats', 'additional-service-seats', 'additional-commerce-seats', 'additional-legacy-contacts'].includes(quantityPackApiName);
};
export const isValidProductLevel = level => {
  return level !== null && level !== undefined && typeof level === 'string' && ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'].includes(level);
};
export const isValidPaidProductLevel = level => {
  return level !== null && level !== undefined && typeof level === 'string' && ['STARTER', 'PROFESSIONAL', 'ENTERPRISE'].includes(level);
};
const isValidSku = sku => {
  return typeof sku === 'object' && sku !== null && 'skuType' in sku;
};
export const isQuantityPackDetails = sku => {
  return isValidSku(sku) && sku.skuType === 'QUANTITY_PACK';
};
export const isProductVersion = sku => {
  return isValidSku(sku) && sku.skuType === 'PRODUCT_VERSION';
};
export const isCoreSeatsApiName = apiName => {
  return [Products.CORE_SEATS_STARTER, Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE].includes(apiName);
};
export const isValidProductLine = productLine => {
  return productLine !== null && productLine !== undefined && typeof productLine === 'string' && ['MARKETING', 'SALES', 'SERVICE', 'CMS', 'OPERATIONS', 'COMMERCE'].includes(productLine);
};
export const isFilteredProductResponse = product => {
  return isValidApiName(product.apiName);
};